var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-related-content" }, [
    _c("h4", { staticClass: "viq-related-content__title" }, [
      _vm._v("Related Content"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-related-content__list" },
      _vm._l(_vm.items, function (item, i) {
        return _c(
          "div",
          {
            key: i,
            staticClass: "viq-related-content__item",
            on: {
              click: function ($event) {
                return _vm.openItem(item)
              },
            },
          },
          [
            item.type
              ? _c("span", { staticClass: "viq-related-content__item-type" }, [
                  _vm._v(_vm._s(item.type)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("h5", { staticClass: "viq-related-content__item-title" }, [
              _vm._v(_vm._s(item.title)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "viq-related-content__item-meta" }, [
              item.jurisdiction
                ? _c("span", [_vm._v(_vm._s(item.jurisdiction))])
                : _vm._e(),
              _vm._v(" "),
              item.date
                ? _c("span", [_vm._v(_vm._s(_vm.formatDate(item.date)))])
                : _vm._e(),
            ]),
            _vm._v(" "),
            item.relationship
              ? _c("span", { staticClass: "viq-related-content__item-rel" }, [
                  _vm._v("\n        " + _vm._s(item.relationship) + "\n      "),
                ])
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }